import $axios from "src/utils/axios";


export const AuthenticateUser = (data) => {
  return $axios.post(`session/jwt-login`, data);
}

export const LogoutUser = () => {
  return $axios.post(`session/jwt-logout`);
}
